import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { NavController } from '@ionic/angular';
import { AuthService } from '../services/auth.service';
import { CommonService } from '../services/common.service';
import { TranslateService } from '@ngx-translate/core';

interface OtpResponse {
  result: boolean;
  message?: string;
  data?: {
    debtor_id: number;
    debtor_name: string;
    debtor_phone?: string;
    debtor_mobile?: string;
    debtor_fax?: string;
    [key: string]: any;
  };
  [key: string]: any; // For any additional properties
}

@Component({
  selector: 'app-otp-verification',
  templateUrl: './otp-verification.page.html',
  styleUrls: ['./otp-verification.page.scss'],
})
export class OtpVerificationPage implements OnInit {
  otpForm: FormGroup;
  isLoading = false;
  caseId: string;
  debtorEmail: string;
  resendDisabled = false;
  resendTime = 30;
  private resendInterval: any;
  
  // For UI
  // background_url = 'assets/images/login-bg.jpg'; // Update with your background image path
  logo_size = '120px';
  remoteToken: string;
  title: string = '`';
  logo_url: string = '';
  footer_title: string = '';
  client = '';
  background_url: string = '';
  datepicker_date_format: string = 'MM/DD/YYYY'
  showNotification: boolean = false;
  login_header_message: string = ''
  login_footer_colour_code: string = ''
  agreement_acceptance: any = {};
  showInfoIcon = false;
  login_footer_message: string;
  agreement_acceptance_label: string;
   state_disclosures: string;
  showMultipleFieldsMessage: boolean = false;
  full_title_login = null;
  swapFields: {
    primary_field: string;
    secondary_field: string;
    secondary_field_label: string;
  };
 
  checkTranslation = false;
  login_button_label: string;
  constructor(
    private formBuilder: FormBuilder,
    private route: ActivatedRoute,
    private router: Router,
    private navCtrl: NavController,
    private authService: AuthService,
    private commonService: CommonService,
    private translate: TranslateService
  ) {
    // Get navigation state
    const navigation = this.router.getCurrentNavigation();
    const state = navigation?.extras?.state as {
      debtorEmail: string;
      caseId: string;
      remoteToken: string;
    };

    if (state) {
      this.debtorEmail = state.debtorEmail;
      this.caseId = state.caseId;
      this.remoteToken = state.remoteToken;
    }
  }

  ngOnInit() {
     let portalSettings = JSON.parse(localStorage.getItem('portal_settings'));
      if (portalSettings?.portal_details?.logo_url) {
        this.logo_url = portalSettings.portal_details.logo_url;
      }
      if (portalSettings?.portal_details?.login_logo_url) {
        this.logo_url = portalSettings.portal_details.login_logo_url;
      }
      if (portalSettings?.portal_details?.background_url) {
        this.background_url = portalSettings.portal_details.background_url;
      }
      if (portalSettings?.datepicker_date_format) {
        this.datepicker_date_format = portalSettings.datepicker_date_format;
      }
      if (portalSettings?.additional_settings?.custom_notifications?.show_notification_panel) {
        this.showNotification = portalSettings.additional_settings.custom_notifications.show_notification_panel;
      }

      //'Having trouble signing in' message. - LU-254
      this.login_header_message = portalSettings?.portal_details?.login_header_message;
      this.login_footer_colour_code = portalSettings?.portal_details?.login_footer_colour_code;
      this.agreement_acceptance = portalSettings?.portal_details?.agreement_acceptance_checkbox;

       if (localStorage.getItem('language') != 'en') {
        console.log(portalSettings?.portal_details);
        console.log(portalSettings?.portal_details?.['agreement_acceptance_label_' + localStorage.getItem('language')]);
        this.agreement_acceptance_label = portalSettings?.portal_details?.['agreement_acceptance_label_' + localStorage.getItem('language')] || portalSettings?.portal_details?.agreement_acceptance_label;
        this.login_footer_message = portalSettings?.portal_details?.['login_footer_message_' + localStorage.getItem('language')] || portalSettings?.portal_details?.login_footer_message;
        this.state_disclosures = portalSettings?.additional_settings?.state_disclosures?.['state_disclosures_' + localStorage.getItem('language')] || portalSettings?.additional_settings?.state_disclosures?.state_disclosures || '';
        this.full_title_login = portalSettings?.portal_details?.['full_title_' + localStorage.getItem('language')] ||  portalSettings?.portal_details?.full_title;
        this.login_button_label = portalSettings?.portal_details?.['login_button_label_' + localStorage.getItem('language')] || portalSettings?.portal_details?.login_button_label;
      }
      else {
        this.agreement_acceptance_label = portalSettings?.portal_details?.agreement_acceptance_label;
        this.login_footer_message = portalSettings?.portal_details?.login_footer_message;
        this.state_disclosures = portalSettings?.additional_settings?.state_disclosures?.state_disclosures;
        this.full_title_login = portalSettings?.portal_details?.full_title;
        this.login_button_label = portalSettings?.portal_details?.login_button_label;
        console.log(this.login_button_label);
      }
      this.logo_size = portalSettings?.portal_details?.logo_size || '120px';
    // Any initialization logic can go here
    this.initForm();
  }

  initForm() {
    this.otpForm = this.formBuilder.group({
      otp: ['', [Validators.required, Validators.pattern('^[0-9]{6}$')]]
    });
  }

  /**
   * Verifies the OTP entered by the user
   */
  async verifyOtp() {
    if (this.otpForm.invalid || !this.debtorEmail) {
      this.commonService.showToast('Please enter a valid OTP', 'danger');
      return;
    }

    this.isLoading = true;
    const otp = this.otpForm.get('otp')?.value;
    
    // Show loading indicator
    await this.commonService.showLoader('Verifying OTP...');

    try {
      const response = await this.authService.verifyOtp(this.debtorEmail, otp).toPromise() as OtpResponse;
      console.log(response);
      
      if (response.result) {
        // Store the token and set login flag
        localStorage.setItem('remote_token', this.remoteToken); // Required by MainGuard
        localStorage.setItem('is_login', 'true');
        
        // Store additional user data if available
        if (response.data) {
          localStorage.setItem('user_data', JSON.stringify(response.data));
        }
        
        // Show success message
        await this.commonService.showToast(response.message || 'OTP verified successfully', 'success');
        
        // Navigate to main page
        await this.router.navigate(['/main']);

      } else {
        // Handle verification failure
        const errorMessage = response?.message || 'Invalid OTP. Please try again.';
        this.commonService.showToast(errorMessage, 'danger');
      }
    } catch (error: any) {
      console.error('OTP Verification Error:', error);
      const errorMessage = error?.error?.message || 'An error occurred during OTP verification. Please try again.';
      this.commonService.showToast(errorMessage, 'danger');
    } finally {
      this.isLoading = false;
      await this.commonService.dismissLoader();
    }
  }

  /**
   * Handles the back button click
   */
  goBack() {
    this.navCtrl.navigateBack(['/login']);
  }
}
